import styled from "styled-components";
import { colors } from "src/theme/colors";
import device from "src/constants/media";
import { typography } from "src/theme";
import media from "src/constants/media";

export const ContentWrapper = styled.div`
  margin: 0 auto;
  padding-bottom: 288px;
  padding-top: 256px;
`;
export const Container = styled.div`
  max-width: 1096px;
  margin: 0 auto;
  position: relative;

  background-color: ${colors.white};
  border-radius: 10px;
  padding: 370px 24px 56px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media ${device.mobileM} {
    padding: 370px 44px 56px;
  }
  @media ${device.tablet} {
    padding: 48px 56px;
  }
`;

export const TextAndButton = styled.div``;
export const Title = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 44px;
  margin-bottom: 20px;
  color: ${colors.greyDark};
  @media ${device.mobileM} {
    padding-right: 50px;
  }
`;
export const Description = styled.div`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  max-width: 422px;
  color: ${colors.grey};
`;

export const FirstImageContainer = styled.div`
  position: absolute;
  //width: 220px;
  //height: 358px;
  //transform: translate(45px, -100%);

  max-width: 340px;
  max-height: 548px;
  height: 330px;
  width: 230px;

  right: 165px;
  top: -65px;

  @media ${device.mobileL} {
    height: 300px;
    width: 200px;
    right: 47%;
    top: -80px;
  }
  @media ${device.tablet} {
    right: 19%;
    top: -60px;
  }
  @media ${device.laptop} {
    width: 500px;
    right: 25%;
    top: -120px;
  }
`;
export const SecondImageContainer = styled.div`
  position: absolute;
  max-width: 340px;
  max-height: 548px;
  height: 330px;
  width: 230px;
  top: -10px;
  right: -20px;

  @media ${device.mobileL} {
    height: 300px;
    width: 200px;
    right: 5%;
    top: -30px;
  }
  @media ${device.tablet} {
    right: 0;
    top: 0;
  }
  @media ${device.laptop} {
    width: 500px;
    right: 0;
    top: -80px;
  }
`;

export const Illustration = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translate(-35%, 35%);

  @media (min-width: 1096px) {
    transform: translate(-75%, 25%);
  }
`;

export const ButtonsWrapper = styled.div`
  padding-top: 40px;
  display: block;
  width: 100%;

  .Button {
    padding-right: 20px;
  }

  @media ${device.mobileL} {
    display: flex;
    flex-direction: row;
    width: fit-content;
  }
`;
export const ButtonItem = styled.div`
  padding-right: 12px;

  @media (min-width: 0px) and (max-width: 429px) {
    padding-right: 12px;
    padding-right: 0;
    padding-top: 10px;
    width: 100%;

    margin-left: auto;
    margin-right: auto;
  }
`;
